const CustomFieldType = {
    TextBox: 1,
    Checkbox: 3,
    RadioButton: 4,
    Section: 5,
    Dropdown: 6,
    Multiselect: 7,
    Date: 8,
    AddFile: 9,
    NewPage: 10,
    HorizontalLine: 11
};

export default CustomFieldType;